module.exports = __webpack_public_path__ + "static/media/contact.80972488.jpg";